module.exports = __webpack_public_path__ + "img/left-bg.566fc6ff.png";